import CryptoJS from "crypto-js";

// Get the encryption key from environment variable
const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;

// Encrypt function using AES
export const encrypt = (text) => {
  if (!ENCRYPTION_KEY) {
    console.error("ENCRYPTION_KEY is not defined in the environment variables.");
    return text;
  }

  return CryptoJS.AES.encrypt(text, ENCRYPTION_KEY).toString();
};
